import { useCallback, useEffect, useState, useSyncExternalStore } from 'react';

import { debounce } from 'lodash';

import { MOBILE_MEDIA_QUERY } from 'constants/breakpoints';

export const useDarkMode = () => {
  const { matches } = useMediaQuery('(prefers-color-scheme: dark)');

  return { isDarkMode: matches };
};

export const useMediaQuery = (mediaQuery: string) => {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const query = window.matchMedia(mediaQuery);
      query.addEventListener('change', onStoreChange);
      return () => query.removeEventListener('change', onStoreChange);
    },
    [mediaQuery],
  );

  const getSnapshot = useCallback(
    () => window.matchMedia(mediaQuery).matches,
    [mediaQuery],
  );

  const matches = useSyncExternalStore(
    subscribe,
    getSnapshot,
    () => undefined as boolean | undefined,
  );

  return { matches };
};

export const useBreakPoint = () => {
  const [isMobile, setIsMobile] = useState(true);

  const updateIsMobile = debounce(
    useCallback(() => {
      setIsMobile(window.matchMedia(MOBILE_MEDIA_QUERY).matches);
    }, []),
    250,
  );

  useEffect(() => {
    updateIsMobile();
    window.addEventListener('resize', updateIsMobile);

    return () => {
      window.removeEventListener('resize', updateIsMobile);
    };
  }, [updateIsMobile]);

  return { isMobile };
};
